module.exports = {"360111001":"青山路街道","360111003":"上海路街道","360111004":"南钢街道","360111100":"京东镇","360111103":"罗家镇","360111104":"湖坊镇","360111105":"塘山镇","360111180":"蛟桥镇（南昌经济技术开发区）","360111400":"南昌昌东工业区","360111481":"白水湖管理处（南昌经济技术开发区）","360111482":"冠山管理处","360111490":"艾溪湖管理处（南昌高新开发区）","360111493":"湖西新建区（南昌高新开发区）"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360111.json
// module id = 1153
// module chunks = 0